/** Staff identity prefixes are minted by the signed room token. */
export function isTeacher(identity: string | undefined): boolean {
  return Boolean(identity && /^(Tutor|Admin|Manager|QualityMember):/.test(identity))
}
